import { useQuery } from "@apollo/client/react";
import { SystemSettingsDocument } from "@/graphql/generated/operations";

// Default brand name when no system-wide app name is configured.
export const DEFAULT_APP_NAME = "smycles";

// Platform app name from systemSettings (set in Branding). Falls back to the
// default when unset/empty. Apollo dedupes and caches the query across callers.
export function useAppName(): string {
  const { data } = useQuery(SystemSettingsDocument);
  return data?.systemSettings?.appName?.trim() || DEFAULT_APP_NAME;
}
